/** FAQ Section
 *  Card is used inside of the dashboard and has some extra props
 *  Section is used inside of the sidebar
 *
 *  Sean: Reaching out to design for clarification on whether
 */
export * from './card'
export * from './section'
